import { FormProvider } from 'react-hook-form'
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/view/components/ui/dialog'
import { BasicInput } from '@/view/components/BasicInput'
import { Button } from '@/view/components/ui/button'
import { cpfMask } from '@/app/utils/cpfFormater'
import { phoneMask } from '@/app/utils/phoneFormater'
import usePersonalInfoFormModal from './usePersonalInfoFormModal'
import ConfirmProposalModal from '../ConfirmProposalModal'

interface PersonalInfoFormModalProps {
  onBack: () => void
  onContinue: () => void
  onSaveProposalData: (data: {
    propostaId: string
    cpf: string
    phone: string
  }) => void
}

export default function PersonalInfoFormModal({
  onBack,
  onContinue,
  onSaveProposalData,
}: PersonalInfoFormModalProps) {
  const {
    form,
    handleSendProposal,
    isLoading,
    isOpenConfirmModal,
    setIsOpenConfirmModal,
    handleVerifyTransactions,
  } = usePersonalInfoFormModal({
    onContinue,
    onSaveProposalData,
  })

  const {
    formState: { errors },
  } = form

  return (
    <DialogContent className="max-h-[740px] overflow-y-auto sm:max-w-2xl">
      <ConfirmProposalModal
        open={isOpenConfirmModal}
        onClose={() => setIsOpenConfirmModal(false)}
        onConfirm={handleSendProposal}
        isLoading={isLoading}
      />
      <DialogHeader className="flex flex-row items-start justify-between border-b pb-8">
        <div>
          <DialogTitle className="text-xl font-semibold text-black01">
            Simular transação
          </DialogTitle>
          <DialogDescription className="!mt-0 text-base text-black04">
            Preencha os campos para gerar a proposta
          </DialogDescription>
        </div>
      </DialogHeader>

      <form onSubmit={handleVerifyTransactions}>
        <FormProvider {...form}>
          <div className="mt-2 flex flex-col space-y-5">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
              <BasicInput
                name="cpf"
                label="CPF"
                error={errors.cpf?.message}
                onInput={cpfMask}
                maxLength={14}
              />
              <BasicInput
                name="name"
                label="Nome"
                error={errors.name?.message}
              />
              <BasicInput
                name="email"
                label="E-mail"
                error={errors.email?.message}
                maxLength={30}
              />
              <BasicInput
                name="phone"
                label="Telefone"
                error={errors.phone?.message}
                onInput={phoneMask}
              />
            </div>
          </div>

          <div className="mt-12 flex justify-end gap-2">
            <Button
              type="button"
              variant="outline"
              className="w-[160px] rounded-full text-primary"
              onClick={onBack}
            >
              Voltar
            </Button>
            <Button
              type="submit"
              className="w-[160px] rounded-full font-semibold text-white"
              isLoading={isLoading}
            >
              Continuar
            </Button>
          </div>
        </FormProvider>
      </form>
    </DialogContent>
  )
}
